export function jsonInit(method: string, body?: any): RequestInit {

    let headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');

    return {
        method: method,
        headers: headers,
        body: JSON.stringify(body)
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./Frontend/src/fetch/fetchFunctions.ts